"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepIconRoot = exports.IconWrapper = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var colors_1 = require("../ThemeProvider/colors");
var styles_1 = require("@mui/material/styles");
exports.IconWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline;\n  @media (max-width: 480px) {\n    display: none;\n  }\n"], ["\n  display: inline;\n  @media (max-width: 480px) {\n    display: none;\n  }\n"])));
exports.StepIconRoot = (0, styled_1.default)('div')(function (_a) {
    var ownerState = _a.ownerState;
    var theme = (0, styles_1.useTheme)();
    var activeStyles = {
        color: theme.palette.primary.main,
        border: "2px solid ".concat(theme.palette.primary.main),
        borderRadius: '50%',
        backgroundColor: 'transparent',
    };
    var completedStyles = {
        backgroundColor: theme.palette.primary.main,
        border: 'none',
        cursor: 'pointer',
        '& .pencilIcon': {
            display: 'none',
        },
        '&:hover': {
            '& .pencilIcon': {
                display: 'inline-block',
            },
            '& .checkIcon, .checkResponsiveIcon': {
                display: 'none',
            },
        },
        '& .checkIcon': {
            display: 'inline-block',
        },
        '& .checkResponsiveIcon': {
            display: 'none',
        },
    };
    return __assign(__assign(__assign({ color: colors_1.tannerGray[600], display: 'flex', width: 36, height: 36, alignItems: 'center', border: "2px solid ".concat(colors_1.tannerGray[300]), borderRadius: '50%', justifyContent: 'center', fontWeight: 700, fontSize: 14, backgroundColor: 'transparent' }, (ownerState.active && activeStyles)), (ownerState.completed && completedStyles)), { '& .StepIcon-completedIcon': {
            zIndex: 1,
            display: 'flex',
            color: colors_1.tannerWhite,
            fontWeight: 700,
        }, '@media (max-width: 480px)': __assign(__assign({ width: 18, height: 18, fontSize: 10, border: "2px solid ".concat(colors_1.tannerGray[200]), backgroundColor: colors_1.tannerGray[200] }, (ownerState.active && activeStyles)), (ownerState.completed && __assign(__assign({}, completedStyles), { '& .checkIcon': {
                display: 'none',
            }, '& .checkResponsiveIcon': {
                display: 'inline-block',
            } }))) });
});
var templateObject_1;
//# sourceMappingURL=styles.js.map